// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__11QYQ","info":"UpdateTermsInfo_info__2CTLi"};